import React, { lazy } from 'react';
import Loadable from 'components/Loadable';
import CommonLayout from 'layout/CommonLayout';

const ConstConsentLogin = Loadable(lazy(() => import('pages/dealerconsent/consent-login')));
const ConstConsentHome = Loadable(lazy(() => import('pages/dealerconsent/consent-home')));
const ConstConsentProgram = Loadable(lazy(() => import('pages/dealerconsent/consent-program')));
const ConstConsentSubmit = Loadable(lazy(() => import('pages/dealerconsent/consent-submit')));


const ConsentRoutes = {
  path: '/',
  element: <CommonLayout />,
  children: [
    {
      path: 'dealerconsent',
      children: [
        {
          path: 'consentlogin',
          element: <ConstConsentLogin />
        },
        {
          path: 'consenthome',
          element: <ConstConsentHome />
        },
        {
          path: 'consentprogram',
          element: <ConstConsentProgram />
        },
        {
          path: 'consentsubmit',
          element: <ConstConsentSubmit />
        }
      ]
    }
  ]
};

export default ConsentRoutes;